import { FC } from 'react';
import useApp from '@/hooks/use-app.hook';
import UserBadge from '../user-badge';
import { AuthUser } from '@/lib/services/auth.service';
import useAppTheme from '@/hooks/use-app-theme.hooks';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

interface Props {
  size?: 'small' | 'medium';
}

const useStyles = createUseStyles({
  orgBadge: {
    width: 40,
    '&.small': {
      width: 24,
      height: 24,
      fontSize: '0.75rem',
    },
  },
});

const OrgBadge: FC<Props> = ({ size = 'medium' }) => {
  const { branding } = useApp();
  const { colorMode } = useAppTheme();
  const styles = useStyles();

  const { portalBadge = { title: '', image: '', darkImage: '' }, badgeTitle } = branding;
  const { image, darkImage } = portalBadge;
  const badgeImage = colorMode === 'dark' ? darkImage : image;
  const compClass = classNames(styles.orgBadge, 'org-badge', size);

  if (badgeImage) {
    return <img src={badgeImage} alt={badgeTitle} className={compClass} />;
  }

  return <UserBadge user={{ displayName: badgeTitle } as AuthUser} size={size} />;
};

export default OrgBadge;
